<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Settings</el-breadcrumb-item>
                <el-breadcrumb-item>Office Name</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="18">
                <div class="main-title">
                    Office Name List
                </div>
            </el-col>
            <el-col :span="6" class="text-right">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="isEdit = false; resetForm(); showCreateDialog = true">New Office</el-button>
            </el-col>
        </el-row>

        <el-card  style="margin-top: 24px"  class="box-card">
            <div slot="header" class="clearfix">
                <span>Filter</span>
            </div>
            <el-row :gutter="8">
                <el-col :span="4">
                    <el-select
                            value-key="id"
                            v-model="query.country"
                            filterable
                            remote
                            clearable
                            autocomplete="nope"
                            placeholder="Select Country"
                            :remote-method="searchCountry"
                            :loading="filter.searchingCountry"
                            size="small"
                            @clear="searchCountry('')"
                            @change="searchFilterCity('')">
                        <el-option
                                v-for="item in filter.countries"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select
                            value-key="id"
                            v-model="query.city"
                            filterable
                            remote
                            clearable
                            autocomplete="nope"
                            placeholder="Select City"
                            :remote-method="searchCity"
                            :loading="filter.searchingCity"
                            size="small"
                            @clear="searchFilterCity('')">
                        <el-option
                                v-for="item in filter.cities"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button @click="searchData" class="filter-item" size="small" type="primary" icon="el-icon-search">
                        Search
                    </el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-row type="flex" style="margin-top:24px">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row style="margin-bottom: 18px" :gutter="15">
                        <el-col :span="4" :offset="16">
                            <status-filter v-model="query.status" @change="queryStatusChanged()"></status-filter>
                        </el-col>
                        <el-col :span="4">
                            <el-input v-model="query.search" size="small" placeholder="Name" class="filter-item" @keyup.enter.native="search"/>
                        </el-col>
                    </el-row>

                    <el-table
                            v-loading="loading"
                            :data="offices"
                            stripe
                            @sort-change="sortChange"
                            :default-sort="query.sort"
                            style="width: 100%">
                        <el-table-column
                                prop="id"
                                label="ID"
                                width="80"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="Name"
                                width="180"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="city.name"
                                label="City">
                        </el-table-column>
                        <el-table-column
                                prop="description"
                                label="Description"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="active"
                                label="Status"
                                sortable>
                            <template slot-scope="scope">
                                {{scope.row.active ? 'Active':'Inactive'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="Actions">
                            <template slot-scope="scope">
                                <el-button size="mini" icon="el-icon-edit" @click="isEdit = true; edit(scope.$index, scope.row)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination v-show="query.total>0" :total="query.total" :page.sync="query.page" :limit.sync="query.limit" @pagination="searchData" />
                </el-card>
            </el-col>
        </el-row>
        <el-dialog v-bind:title="dialogTitle" :visible.sync="showCreateDialog">
            <el-form :model="form" ref="dataForm" :rules="dataRules" v-loading="saving">
                <el-form-item :required="true" label="Name" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="City" prop="city" :label-width="formLabelWidth">
                    <el-select
                            style="width: 100%"
                            value-key="id"
                            v-model="form.city"
                            filterable
                            remote
                            placeholder="Select a City"
                            :remote-method="searchCity"
                            :loading="searchingCity">
                        <el-option
                                v-for="item in cities"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Description" :label-width="formLabelWidth" prop="description">
                    <el-input type="textarea" v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item >
                    <div class="switch-label" style="width: 108px;" >Active</div> <el-switch v-model="form.active"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showCreateDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="save()">Save</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import _ from "lodash";
import api from '@/services/api/WRCService'
import Pagination from "@/components/Pagination"
import StatusFilter from '@/components/StatusFilter'

export default {
    components: { Pagination, StatusFilter },
    data: function() {
        var validateName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please enter Name'));
            } else {
                callback();
            }
        };
        return {
            dataRules: {
                name: [
                    { validator: validateName, trigger: 'blur' }
                ],
                city: [
                    {required: true, message: 'Please select city', trigger: 'blur'}
                ]
            },
            showCreateDialog: false,
            formLabelWidth: '120px',
            form: {
              name: '',
              description: '',
              active: true
            },
            dialogTitle: 'New Office Name',
            saving: false,
            loading: false,
            countryLoading: false,
            searchingCity: false,
            cities: [],
            offices: [],
            countryData:[],
            isEdit: false,
            filter: {
                searchingCountry: false,
                searchingCity: false,
                countries: [],
                cities: []
            },
            query: {
                total: 0,
                page: 0,
                limit: 10,
                pageSize: 0,
                search: null,
                city: null,
                country:null,
                status: 'Active',
                sort: {
                    prop: 'id',
                    order: 'ascending',
                    orderVal: 'asc'
                }
            }
        }
    },
    watch: {
        form : function() {
            if (_.isUndefined(this.form.id)) {
                this.dialogTitle = 'New Office Name';
            } else {
                this.dialogTitle = 'Edit Office Name';
            }
        }
    },
    methods:{
        search() {
            this.query.page = 1;
            this.searchData();
        },
        searchData() {
            this.loading = true;

            var active = null

            if (this.query.status === "Active") {
                active = true
            } else if (this.query.status === "Inactive") {
                active = false
            }

            api.filterOffices(this.query.search, {
                page: this.query.page - 1,
                size: this.query.limit,
                sort: this.query.sort.prop,
                dir: this.query.sort.orderVal
            }, {
                cityId: this.query.city,
                countryId: this.query.country
            }, active).then(({ data }) => {

                this.offices.splice(0, this.offices.length);
                this.offices.push(...data.data.items);
                this.query.total = data.data.pagination.totalRecords;
            }).catch(() => {}).then(() => {
                this.loading = false;
            });
        },
        queryStatusChanged() {
            this.search()
        },
        sortChange(data) {
            const { prop, order } = data;
            if(prop == null){
                this.query.sort = {
                    prop: 'id',
                    order: 'ascending',
                    orderVal: 'asc'
                };
            }else {
                this.query.sort = {
                    prop: prop,
                    order: order,
                    orderVal: order === 'ascending' ? 'asc' : 'desc'
                }
            }

            this.searchData()
        },
        edit(idx, data) {

            this.form = {
                id: data.id,
                name: data.name,
                city: data.city,
                description: data.description,
                active: data.active
            };

            this.showCreateDialog = true;
        },
        resetForm() {
            this.saving = false;

            this.form = {
              description: '',
              active: true
            }

            setTimeout(() => {
                if (!_.isUndefined(this.$refs['dataForm'])) {
                    this.$refs['dataForm'].clearValidate();
                }
            }, 1);
        },
        save() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.saving = true;
                    if (_.isUndefined(this.form.id)) {
                        let params = {
                            name: this.form.name,
                            cityId: this.form.city.id,
                            description: this.form.description,
                            active: this.form.active
                        }

                        api.createOffice(params).then(() => {
                            this.$message({
                              message: 'Successfully added Office Name.',
                              type: 'success'
                            });
                        }).catch(() => {}).then(() => {
                            this.saving = false;
                            this.searchData();
                            this.showCreateDialog = false;
                        });
                    } else {
                        let params = {
                            officeId: this.form.id,
                            name: this.form.name,
                            cityId: this.form.city.id,
                            description: this.form.description,
                            active: this.form.active
                        }

                        api.updateOffice(params).then(() => {
                            this.$message({
                              message: 'Successfully updated Office Name.',
                              type: 'success'
                            });
                        }).catch(() => {}).then(() => {
                            this.saving = false;
                            this.searchData();
                            this.showCreateDialog = false;
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        searchCountry(query) {
            this.filter.searchingCountry = true;
            api.getCountries(query, {
                page: 0,
                size: 200
            }).then(({data}) => {
                this.filter.countries.splice(0, this.filter.countries.length);
                if(query === ''){
                    this.filter.countries.push({
                        id: null,
                        name: 'Select Country'
                    })

                    this.query.country = null;
                }
                this.filter.countries.push(...data.data.items);
            }).catch(() => {}).then(() => {
                this.filter.searchingCountry = false;
            });
        },
        searchFilterCity(query){
            this.filter.city = null;
            this.filter.searchingCity = true;
            api.getCities({
                name: query,
                countryId: this.query.country
            }, {
                page: 0,
                size: 100
            }).then(({data}) => {

                this.filter.cities.splice(0, this.cities.length);
                if(query === '') {
                    this.filter.cities.push({
                        id: null,
                        name: 'Select City'
                    });
                    this.query.city = null;
                }
                this.filter.cities.push(...data.data.items);
            }).catch(() => {
            }).then(() => {
                this.filter.searchingCity = false;
            });
        },
        searchCity(query) {
            this.searchingCity = true;

            api.getCities({
                name: query
            }, {
                page: 0,
                size: 100
            }).then(({data}) => {

                this.cities.splice(0, this.cities.length);
                this.cities.push(...data.data.items);
            }).catch(() => {
            }).then(() => {
                this.searchingCity = false;
            });
        },
    },
    mounted() {
        this.query.page = 1;
        this.searchData();
        this.searchCity('');
        this.searchCountry('');
    }
}
</script>
